import L from "leaflet";
import "leaflet-tracksymbol";
import utils from "@/utils";

export default {
  SYMBOL_ARROW: [0.75, 0, -0.5, 0.4, -0.25, 0, -0.5, -0.4],
  SYMBOL_SQUERE: [0.3, 0.3, -0.3, 0.3, -0.3, -0.3, 0.3, -0.3],
  SYMBOL_CIRCLE: [0.3, 0.0, 0.28, 0.11, 0.21, 0.21, 0.11, 0.28, 0.0, 0.3, -0.11, 0.28, -0.21, 0.21, -0.28, 0.11, -0.3, 0.0, -0.28, -0.11, -0.21, -0.21, -0.11, -0.28, -0.0, -0.3, 0.11, -0.28, 0.21, -0.21, 0.28, -0.11],
  COLOR_ACTIVE: "#005ea1",
  COLOR_ACTIVE_FILL: "#93feff",
  COLOR_FAIL: "#b65000",
  COLOR_FAIL_FILL: "#ff812b",

  MAP_LAYRES: [
    {
      title: "Openstreetmap",
      title_i18n: "map.title.base",
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution: "&copy; <a href=\"http://osm.org/copyright\">OpenStreetMap</a> contributors",
      google: false,
      enabled: true
    },
    {
      title: "Mapy CZ",
      title_i18n: "map.title.base",
      url: "https://mapserver.mapy.cz/base-m/{z}-{x}-{y}.png",
      attribution: "&copy; <a href=\"https://mapy.cz\">Mapy.cz</a>",
      google: false,
      enabled: false
    },
    {
      title: "Mapy CZ",
      title_i18n: "map.title.satellite",
      url: "https://mapserver.mapy.cz/ophoto-m/{z}-{x}-{y}.png",
      attribution: "&copy; <a href=\"https://mapy.cz\">Mapy.cz</a>",
      google: false,
      enabled: false
    },
    {
      title: "Google",
      title_i18n: "map.title.base",
      type: "roadmap",
      layer: null,
      url: "",
      attribution: "&copy; <a href=\"https://maps.google.com\">Google maps</a>",
      google: true,
      enabled: true
    },
    {
      title: "Google",
      title_i18n: "map.title.traffic",
      type: "roadmap",
      layer: "TrafficLayer",
      url: "",
      attribution: "&copy; <a href=\"https://maps.google.com\">Google maps</a>",
      google: true,
      enabled: true
    },
    {
      title: "Google",
      title_i18n: "map.title.satellite",
      type: "satellite",
      layer: null,
      url: "",
      attribution: "&copy; <a href=\"https://maps.google.com\">Google maps</a>",
      google: true,
      enabled: true
    }
  ],

  trackSymbol(latlng, options) {
    var ts = L.trackSymbol(latlng, {
      trackId: options.trackId || 0,
      fill: options.fill || true,
      fillColor: options.fillColor || this.COLOR_ACTIVE_FILL,
      fillOpacity: options.fillOpacity || 1.0,
      stroke: options.stroke || true,
      color: options.color || this.COLOR_ACTIVE,
      opacity: options.opacity || 1.0,
      weight: options.weight || 1.0,
      speed: undefined,
      course: undefined,
      heading: options.heading || 0,
      defaultSymbol: options.defaultSymbol || this.SYMBOL_SQUERE,
      noHeadingSymbol: options.noHeadingSymbol || [0.3, 0, 0, 0.3, -0.3, 0, 0, -0.3],
      silouetteSymbol: options.silouetteSymbol || [1, 0.5, 0.75, 1, 0, 1, 0, 0, 0.75, 0],
      gpsRefPos: options.gpsRefPos || undefined,
      minSilouetteZoom: options.minSilouetteZoom || 14,
      leaderTime: options.leaderTime || 60,
      size: options.size || 24,
      data: options.data || {}
    });

    // workaround leaflet 1.8.0 and trackSYmbol
    delete ts["_leaflet_id"];
    return ts;
  },

  trackSymbolVehicleOptions(vehicle) {
    var options = {};

    if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished") {
      if (vehicle.location.speed >= 5) {
        options.defaultSymbol = this.SYMBOL_ARROW;
        options.heading = vehicle.location.direction * (Math.PI / 180.0);
      } else {
        options.defaultSymbol = this.SYMBOL_CIRCLE;
        options.heading = 0;
      }
    } else {
      options.defaultSymbol = this.SYMBOL_SQUERE;
      options.heading = 0;
    }

    switch (utils.vehicleState(vehicle)) {
      case "FAIL":
        options.color = this.COLOR_FAIL;
        options.fillColor = this.COLOR_FAIL_FILL;
        break;
      default:
        options.color = this.COLOR_ACTIVE;
        options.fillColor = this.COLOR_ACTIVE_FILL;
        break;
    }

    return options;
  }
};